import React, {Fragment, useMemo, useRef} from 'react';

import {PopoverBody} from 'reactstrap';
import styled from 'styled-components';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {PopoverForm, PopoverHeading} from 'app/general/overlays';
import {EditableTagsSelect} from 'app/tags/components/EditableTagsSelect';
import {gt, ngt} from 'app/utils/i18n';

import {EditTagsDocumentType} from '../types';

import {TaggedItemSerializedType} from 'sweet-types';

import type {OverlayProps} from 'app/general/overlays';

interface Props {
  overlayProps: OverlayProps;
  documents: Array<EditTagsDocumentType>;
  onSuccess: (doc?: EditTagsDocumentType) => any;
}

export const EditTagsDocumentPopover = ({
  overlayProps,
  documents,
  onSuccess,
}: Props): JSX.Element => {
  const refreshPopover = useRef<() => void>(() => undefined);

  const taggedItems: Array<TaggedItemSerializedType> = useMemo(
    () =>
      Object.values(
        documents
          .flatMap((document) => document.tags)
          .reduce((acc, item) => {
            acc[item.html_url] = item;
            return acc;
          }, {})
      ),
    [documents]
  );

  return (
    <PopoverForm overlayProps={overlayProps}>
      {({close, refreshPosition}) => {
        // used to refresh the page when toggled.
        refreshPopover.current = refreshPosition;
        return (
          <Fragment>
            <PopoverBody className="m-0 p-0">
              <StyledScrollableContainerDiv className="d-flex flex-column">
                <PopoverHeading>
                  {ngt(
                    `Edit tags (${documents.length} document selected)`,
                    `Edit tags (${documents.length} documents selected)`,
                    documents.length
                  )}
                </PopoverHeading>
                <div className="m-2">
                  <EditableTagsSelect
                    canCreateTags={true}
                    documents={documents}
                    selected={taggedItems}
                    onChange={(promise) => promise.then(onSuccess)}
                  />
                </div>
              </StyledScrollableContainerDiv>
            </PopoverBody>
            <StyledPopoverBottomDIV>
              <button onClick={close} className="btn btn-link btn-sm">
                <i className="fa fa-times" /> {gt('Close')}
              </button>
            </StyledPopoverBottomDIV>
          </Fragment>
        );
      }}
    </PopoverForm>
  );
};

const StyledScrollableContainerDiv = styled.div`
  max-height: calc(100vh - 200px);
  width: 274px;
`;
